import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { INSPECTORS_ENDPOINTS } from '../../api/endpoints/inspectors.endpoints';
import { ADMIN_ORDERS_ENDPOINTS } from '../../api/endpoints/admin-orders.endpoints';
import { NOTIFICATIONS_ENDPOINTS } from '../../api/endpoints/notifications.endpoints';

@Injectable({
  providedIn: 'root',
})
export class InspectorsService {
  private api = inject(ApiService);

  getAvailableInspectors(params): Observable<any> {
    return this.api.get(INSPECTORS_ENDPOINTS.V1.AVAILABLE_INSPECTORS, {
      params: params,
    });
  }

  deleteInspector(inspectorId): Observable<any> {
    return this.api.delete(INSPECTORS_ENDPOINTS.V1.INSPECTOR(inspectorId));
  }

  deleteInspectorFile(inspectorId, fileName): Observable<any> {
    return this.api.post(
      INSPECTORS_ENDPOINTS.V1.DELETE_INSPECTOR_DOCUMENT(inspectorId),
      fileName,
    );
  }

  getPrivateNotifications(id, params): Observable<any> {
    return this.api.get(
      NOTIFICATIONS_ENDPOINTS.V1.PRIVATE_NOTIFICATION_DETAIL(id),
      { params: params },
    );
  }

  getGeneralNotifications(params): Observable<any> {
    return this.api.get(NOTIFICATIONS_ENDPOINTS.V1.GENERAL_NOTIFICATION, {
      params: params,
    });
  }

  getCategories(): Observable<any> {
    return this.api.get(INSPECTORS_ENDPOINTS.V1.INSPECTOR_CATEGORIES);
  }

  getInspectorByID(id): Observable<any> {
    return this.api.get(INSPECTORS_ENDPOINTS.V1.INSPECTOR_DETAIL(id));
  }

  getAcadamicMajor(): Observable<any> {
    return this.api.get(INSPECTORS_ENDPOINTS.V1.ACADEMIC_MAJORS);
  }

  assignInspector(inspectorId, data): Observable<any> {
    return this.api.post(
      INSPECTORS_ENDPOINTS.V1.ASSIGN_INSPECTOR(inspectorId),
      data,
    );
  }

  reassignInspector(inspectorId, data): Observable<any> {
    return this.api.post(
      INSPECTORS_ENDPOINTS.V1.BULK_REASSIGN_INSPECTOR(inspectorId),
      data,
    );
  }

  changePaymentInspectorsStatus(orderIDs: number[], isPaid: boolean): Observable<any> {
    let data = {
      is_paid: isPaid,
      orders_ids: orderIDs,
    };
    return this.api.put(ADMIN_ORDERS_ENDPOINTS.V1.INSPECTOR_SHARE_IS_PAID, data);
  }

  getSpecialQualifications(): Observable<any> {
    return this.api.get(INSPECTORS_ENDPOINTS.V1.SPECIAL_QUALIFICATIONS_TAGS);
  }

  addSpectialQualification(specialQualification: string): Observable<any> {
    const data = {
      name: specialQualification,
    };
    return this.api.post(
      INSPECTORS_ENDPOINTS.V1.SPECIAL_QUALIFICATIONS_TAGS,
      data,
    );
  }

  updateSpecialQualification(
    specialQualification: string,
    id,
  ): Observable<any> {
    const data = {
      name: specialQualification,
    };
    return this.api.put(
      INSPECTORS_ENDPOINTS.V1.SPECIAL_QUALIFICATIONS_TAG_DETAIL(id),
      data,
    );
  }

 

  getAvailableQualityControl(params): Observable<any> {
    return this.api.get(INSPECTORS_ENDPOINTS.V1.AVAILABLE_QCS, { params: params });

  }

  postAdditionalExpert(data): Observable<any> {
    return this.api.post(INSPECTORS_ENDPOINTS.V1.ORDER_BY_EXPERT, data);
  }

  deleteAdditionalExpert(expertId): Observable<any> {
    return this.api.delete(INSPECTORS_ENDPOINTS.V1.ORDER_BY_EXPERT_DETAIL(expertId));
  }

   handleError(error) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
